import { ToolbarButtonAction } from "src/app/components/grid/SimpleEntityGrid";

const useTitleIAGridToolbarButtons = (): ToolbarButtonAction => {
    return {
        active: true,
        export: true,
    };
};

export default useTitleIAGridToolbarButtons;
